import { get, post } from "./lib/api"

// Session-scoped SSO values, fetched rather than rendered because /login is
// CDN-cached. Mirrors RefreshFormAuthenticityToken's handling of the CSRF token.
let sessionContextPromise

export function fetchSessionContext() {
  return (sessionContextPromise ||= get(`/session_context.json?gf=${new Date().getTime()}`))
}

export function createSsoCallbackUrl(callbackUrl, urlOption) {
  let ssoCallbackUrl = callbackUrl
  const params = Object.entries(urlOption || {})
  if (params.length) {
    ssoCallbackUrl += (callbackUrl.includes("?") ? "&" : "?") + new URLSearchParams(params)
  }
  return ssoCallbackUrl
}

export async function applePost(ssoCallbackUrl, data) {
  try {
    return post(ssoCallbackUrl, data).then(response => {
      if (response.redirect) {
        window.location.assign(response.redirect)
      }
    })
  } catch (error) {
    throw new Error("Your Apple ID authentication failed.", { cause: error })
  }
}

export function facebookSSO(callbackUrl, urlOption, callbackOptions = {}) {
  const options =
    callbackOptions && typeof callbackOptions === "object" ? callbackOptions : {}
  const ssoCallbackUrl = createSsoCallbackUrl(callbackUrl, urlOption)
  const opts = { scope: "email" }
  if (options.fbReauth) {
    opts.auth_type = "rerequest"
  }

  return new Promise((resolve, reject) =>
    FB.login(function (response) {
      if (response.authResponse) {
        // access_token is the only field the server reads; fbReauth is consumed
        // locally above (opts.auth_type) and must not leak into the POST body.
        resolve(post(ssoCallbackUrl, { access_token: response.authResponse.accessToken }))
      } else {
        const ssoErrorMessage = "Facebook could not verify your account."

        reject(new Error(ssoErrorMessage))
      }
    }, opts)
  )
}
